import {
  NotificationsApi,
  ActivityDigestCadence,
  type ActivityNotificationsFamilyUnread,
  type ActivityNotificationsSummaryResponse,
  type NotificationPreferencesResponse,
  type UpdateNotificationPreferencesBody
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

export { ActivityDigestCadence };
export type {
  ActivityNotificationsFamilyUnread,
  ActivityNotificationsSummaryResponse,
  NotificationPreferencesResponse,
  UpdateNotificationPreferencesBody
};

/**
 * Wrapped notifications API (preferences + in-app unread watermark).
 */
class WrappedNotificationsApi {
  async getPreferences(): Promise<ApiResult<NotificationPreferencesResponse>> {
    return withApiSetup(
      (config) => new NotificationsApi(config),
      getApiConfiguration,
      (api) => api.getPreferences()
    );
  }

  async updatePreferences(
    body: UpdateNotificationPreferencesBody
  ): Promise<ApiResult<NotificationPreferencesResponse>> {
    return withApiSetup(
      (config) => new NotificationsApi(config),
      getApiConfiguration,
      (api) => api.updatePreferences(body)
    );
  }

  async getActivityNotificationsSummary(): Promise<ApiResult<ActivityNotificationsSummaryResponse>> {
    return withApiSetup(
      (config) => new NotificationsApi(config),
      getApiConfiguration,
      (api) => api.getActivityNotificationsSummary()
    );
  }

  async markActivityNotificationsSeen(): Promise<ApiResult<ActivityNotificationsSummaryResponse>> {
    return withApiSetup(
      (config) => new NotificationsApi(config),
      getApiConfiguration,
      (api) => api.markActivityNotificationsSeen()
    );
  }
}

export const notificationsApi = new WrappedNotificationsApi();
